

































































































































import Vue from 'vue';
// import Switches from 'vue-switches';
import UnitManager from '@/common/classes/unit.manager';
import {Expense,UnitExpense,RefExpense,CostExpense} from '@/common/classes/expenses';
import ListExpense from '@/components/constructor-product-tab/ListExpense.vue';
import ChartMethods from '@/components/mixins/ChartMethods.vue';
import MiscMixin from '@/components/mixins/MiscMixin.vue';

import ProjectUnitsModal from '@/components/ProjectUnitsModal.vue';
import { getUniqueName, jsonCycler, smartToFixed, numberWithSpaces, processResponseError, isMobile, createClickAnchor } from '@/common/misc';
import { getAuthOnlyFeatureDialogObj, getIndustries, Industry } from '@/common/config';
import { ProductModel, ProjectModel } from '@/common/classes/models';

import { mapGetters } from 'vuex';
import { SET_PRODUCT } from '@/store/mutations';
import { SAVE_PROJECT } from '@/store/actions';

import draggable from 'vuedraggable';
import VueContext from 'vue-context';
import 'vue-context/src/sass/vue-context.scss';
import channelManager from '@/common/classes/channel.manager';
import UploadImageMixin from '@/components/mixins/UploadImageMixin.vue';
import productManager from '@/common/classes/product.manager';
import SpecialExpenses from './SpecialExpenses.vue';
import TaxUtils, { getProductTaxesMap } from '@/common/classes/tax.utils';
import chartMethods from '@/common/classes/chart.methods';

let lastClickExpense:Expense;
let lastClickHoverExpense:Expense;

//FIXME: Expense type containers don't fold properly if they use taxes
export default Vue.extend({
  name: 'productTab',
  components: {
    ListExpense,
    VueContext,
    draggable,
    ProjectUnitsModal,
    SpecialExpenses,
  },
  mixins: [ChartMethods,MiscMixin,UploadImageMixin],
  data(){
    return {
      inputDump: {
        newExpenseInputHasSubExpenses: false,
        newExpenseInputName: '',
        setExpenseType: -1,
        newExpenseNameFocused: false,
        // -1 - not clicked, 0 - waiting for second click, 1 - format mode active
        formatSetExpenseTypeStatus: -1,
        foldedExpenseLists: [false,false,false],
      },
      //TODO: Refactor lastClickExpense, lastClickHoverExpense, hoverExpense
      lastClickExpense,
      lastClickHoverExpense,
      //Last expense 
      hoverExpense: undefined as Expense|undefined,
      isSavingProject: false,
      retentionCheck: false,
      industries: getIndustries()
    };
  },
  mounted():void{
    if((window as any).webpackHotUpdate){
      const stringifyProject = () => JSON.stringify({product:this.product,channels:this.channels},jsonCycler(),2);
      (window as any).getJSON = stringifyProject;
      (window as any).logJSON = ()=>console.log(stringifyProject());
    }
    UnitManager.tryAddDefaultUnits();
  },
  watch: {
    //TODO: Figure out why not all store expense types are changed
    useStructure(newValue:boolean):void{
      if(!newValue) {
        this.$set(this.inputDump,'setExpenseType',-1);
        (this.product as ProductModel).expenses.forEach((expense)=>expense.setType(-1));
      }
    },
    retention(newVal){
      Vue.nextTick(()=>{
        this.retentionCheck = this.product.retention!=-1
      });
    },
    retentionCheck(newVal:boolean){
      if(this.product.retention != -1 && newVal == true) return;
      this.product.retention = newVal ? 0 : -1;
    },
    // compNewExpInputName(newVal:string){
    //   if(this.expensePresets.find((e)=>e.name.toLowerCase()==newVal.toLowerCase())) 
    //     this.addExpenseFromForm();
    // },
    currentIndustry(newVal:Industry){
      if(newVal && !this.product.unit) this.product.unit = newVal.unitName;
    }
  },
  methods: {
    //#region Load, save projects
    async saveProject(data?:{uploadUserImagePromise:()=>Promise<string>}){
      const {product,channels} = this;
      if((this as any).isAuthenticated === false) {
        this.$modal.show('dialog', getAuthOnlyFeatureDialogObj(()=>this.$modal.hide('dialog'), 'Сохранения проекта доступно только для авторизованных пользователей'));
        return;
      }
      const proj = new ProjectModel(product,channels,this.projectData);
      if(!proj.data.name){
        this.$emit('show-project-dialog');
        return;
      }
      this.isSavingProject = true;
      try{ 
        if(data&&data.uploadUserImagePromise&&typeof data.uploadUserImagePromise == 'function'){
          const uploadImgUrl = await data?.uploadUserImagePromise();
          if(uploadImgUrl) this.projectData.imageLink = uploadImgUrl;
        }
      }catch(e){ 
        alert('При загрузке изображения произошла ошибка. '+processResponseError(e)); 
      }
      try{
        await this.$store.dispatch(SAVE_PROJECT,proj);
        this.$emit('set-unsaved-changes',false)
      }catch(e){
        this.isSavingProject = false;
        const hideDialog = ()=>this.$modal.hide('dialog');
        const dialogText = processResponseError( e );
        const isProjectLimitExceededError = typeof dialogText == 'string' && dialogText.includes('Пользователь превысил лимит на количество сохраненных проектов');
        this.$modal.show('dialog',{
          title: 'При сохранении проекта произошла ошибка.',
          text: processResponseError( e ),
          buttons: [
            {
              title:'ОК',
              handler:hideDialog
            },
            ...(!isProjectLimitExceededError ? [] : [{
              title: 'Список проектов',
              handler(){
                createClickAnchor('/projects', (a)=>a.target = '_blank');
                hideDialog();
              },
            }])
          ],
        })
        throw e;
      }
      this.isSavingProject = false;
    },
    //#endregion
    inputSetExpenseTypeClick(e:any):void{
      const value = parseInt( e.target.value );
      const isSameValue = value == this.inputDump.setExpenseType;
      if(isSameValue && !this.formatSetExpenseType) this.inputDump.formatSetExpenseTypeStatus = 1;
      else this.inputDump.formatSetExpenseTypeStatus = 0;
      // double click
      // this.inputDump.formatSetExpenseTypeStatus = this.inputDump.formatSetExpenseTypeStatus == 0 && isSameValue ? 1 : 0;
      // const timeoutStartType = value;
      // setTimeout(()=>{
      //   if(!this.formatSetExpenseType && timeoutStartType == this.inputDump.setExpenseType){
      //     this.inputDump.formatSetExpenseTypeStatus = -1;
      //   }
      // },1500);
      this.$set( this.inputDump, 'setExpenseType', value);
    },
    onDrag(isDrag:boolean,e:any):void{
      let refs = this.$refs['listExpense'] as Vue[];
      if(refs && !Array.isArray(refs)) refs = [refs];
      const vueExpenses = refs;
      vueExpenses.forEach((v:any)=>v.onDrag(isDrag));
      // this.$forceUpdate();
    },
    //TODO: Try to find a way to refactor draggable/collapsible elements to avoid solutions like these:
    styleForExpenseCollapsible(area:any):any{
      const {avgCheckTax, constTax} = getProductTaxesMap();
      if(area.type == 1 && TaxUtils.isTaxActive( avgCheckTax )) return {'margin-top': '115px'};
      if(area.type == 2 && TaxUtils.isTaxActive( constTax )) return {'margin-top': '60px'};
      return;
    },
    processExpenseTypeToClassMap(type:number,map:any[]):string{
      return map.filter(({t})=>t==type)[0].c||''
    },
    addExpenseToProduct(expense:Expense):void{
      this.product.expenses.push(expense);
    },
    addExpenseFromPreset(preset:Expense):void{
      const {name,type} = preset;
      const createdExpense = this.expenseDetail(this.product.expenses,name,type)
      this.product.expenses.push(createdExpense)
    },
    addExpenseFromForm(type=-1):void{
      let {newExpenseInputName} = this.inputDump;
      // if(!newExpenseInputName || !newExpenseInputName.trim()) newExpenseInputName = 'Новая затрата';
      this.inputDump.newExpenseInputName = "";

      const {expenses} = this.product;
      const expense = this.expenseDetail(expenses,newExpenseInputName,type);
      expense.isDragged = false;
      expense.name = '';
      // const matchingExpensePreset = this.expensePresets.find((e)=>e.name.toLowerCase()==expense.name.toLowerCase());
      // if(this.product.useStructure && matchingExpensePreset) expense.setType(matchingExpensePreset.type);
      expenses.unshift(expense);
    },
    onAddSubExpense(expense:Expense) : void {
      if(expense.subExpenses == undefined)
        expense.changeToExpense();
      expense.addSubExpense(this.expenseDetail(expense.subExpenses,undefined,expense.type));
    },
    getUniqueExpenseName(expenses:Expense[],baseName:string):string{
      return getUniqueName(baseName,expenses.map((e)=>e.name));
    },
    //#region mouse methods
    mouseClick(expense:Expense){
      if(this.inputDump.setExpenseType != -1){
        expense.setType(this.inputDump.setExpenseType);
        if(!this.formatSetExpenseType) this.inputDump.setExpenseType = -1;
      }
    },
    //#endregion
    expenseCtxMenu(e:any,expense:Expense){
      const ctxMenu:any = this.$refs['ctx-menu'];
      ctxMenu.open(e);
      if(this.hoverExpense) this.lastClickHoverExpense = this.hoverExpense;
      this.lastClickExpense = expense;
    },
    duplicateExpense(){
      const {lastClickHoverExpense} = this;
      if(!lastClickHoverExpense) return;
      lastClickHoverExpense.duplicate();
      this.$store.commit(SET_PRODUCT,this.product);
    },
    //#region create expenses
    expenseWithSub(siblings:Expense[]|undefined,name="Новая затрата",type=-1):Expense{
      if(siblings) name = this.getUniqueExpenseName(siblings,name)
      return new Expense(name,type,[this.expenseDetail(undefined,undefined,type)]);
    },
    expenseDetail(siblings:Expense[]|undefined,name="Новая затрата",type=-1):CostExpense|UnitExpense{
      if(siblings) name = this.getUniqueExpenseName(siblings,name);
      const {useUnit} = this.product;
      let ret:UnitExpense|CostExpense;
      ret = new CostExpense(name,0);
      ret.setType(type);
      return ret;
    },
    _computeGetExpType(type:number){
      return (this.product as ProductModel).expenses.filter((e)=>e.type == type);
    },
    _computeSetExpType(newVal:Expense[],type:number){
      //Set expense type if it was dragged from another list
      newVal.forEach((e)=>{ 
        if(e.type!=type) e.setType(type); 
      });
      // let sortCalls:any[] = [];
      //Sort expenses that were stored according to indexes in computed arrays
      const sorted = (this.product as ProductModel).expenses
      .sort((a,b)=>a.type-b.type)
      .sort((a,b)=>{
        // console.log(a.name+' '+a.type+', '+b.name+' '+b.type);
        if(a.type != type || b.type != type){return 0;}
        const byUUID = (exp:Expense)=> (e:Expense)=>e.uuid == exp.uuid;
        const 
          aI=newVal.findIndex(byUUID(a)),
          bI=newVal.findIndex(byUUID(b));
        // sortCalls.push({a:a.name,b:b.name,aI,bI,res:aI-bI})
        return aI - bI;
      });
      // console.log({sorted:sorted.map((e)=>e.name),current:this.product.expenses.map((e:Expense)=>e.name),newVal:newVal.map((e)=>e.name),sortCalls});
      Vue.set( this.product, 'expenses', sorted);
    },
    //#endregion
  },
  computed: {
    // used for watcher
    // compNewExpInputName():string{
    //   return this.inputDump.newExpenseInputName;
    // },
    showclientsPerSalesUnit():boolean { return productManager.showclientsPerSalesUnit(); },
    displayMarketingCost():number{
      return channelManager.getAvgSingleSaleCost();
    },
    displayMarketingCostOneClient():number{
      return channelManager.getAvgSingleSaleCost() / this.product.clientsPerSalesUnit;
    },
    currentIndustry():Industry{
      return this.industries[this.product.industry];
    },
    expenseTypeAreas():{type:number,expenses:Expense[],b:any,p:string,label:string,collapseClick:()=>void,isCollapsed:()=>boolean}[]{
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      let baseData = [
        {expenses:self.unknownExpenses, b:self,p:'unknownExpenses', label:''},
        {expenses:self.unitExpenses, b:self,p:'unitExpenses', label:'Переменные затраты + маркетинг и продажи'+(TaxUtils.isExpenseTypeRelatedToCurrentTax(0) ? ' + налог (на единицу продаж)' : ' (на единицу продаж)')},
        {expenses:self.constExpenses, b:self,p:'constExpenses', label:'Постоянные затраты'+(TaxUtils.isExpenseTypeRelatedToCurrentTax(1) ? ' + налог (за месяц)' : ' (за месяц)')},
        {expenses:self.onetimeExpenses, b:self,p:'onetimeExpenses', label:'Разовые затраты'},
      ] as Array<Record<string,any>>;
      
      const {foldedExpenseLists: foldLists} = self.inputDump;
      for (let i = 0; i < baseData.length; i++){ 
        const cI = i-1; //type index with offset (-1,0,1,2)
        baseData[i] = {
          type:cI,
          collapseClick: () => self.$set( foldLists,cI, !foldLists[cI] ),
          isCollapsed: () => foldLists[cI],
          totalCost: () => { 
            let totalCost = this.product.expenses.filter((e:Expense)=>e.type==cI).reduce((acc:number,e:Expense)=>e.countCost()+acc,0);
            if(cI == 0) totalCost += this.displayMarketingCost;
            const earnings = chartMethods.getUnitEarnings();
            const profits = (this as any).monthlyProfit;
            totalCost += TaxUtils.countTaxCostForExpenseType(cI, earnings, profits);
            return totalCost;
          },
          ...baseData[i]
        };
      }
      return baseData as any;
    },
    unknownExpenses: {
      get():Expense[]{ return this._computeGetExpType(-1) },
      set(newVal:Expense[]){ this._computeSetExpType(newVal,-1); }
    },
    unitExpenses: {
      get():Expense[]{ return this._computeGetExpType(0) },
      set(newVal:Expense[]){ this._computeSetExpType(newVal,0); }
    },
    constExpenses: {
      get():Expense[]{ return this._computeGetExpType(1) },
      set(newVal:Expense[]){ this._computeSetExpType(newVal,1); }
    },
    onetimeExpenses: {
      get():Expense[]{ return this._computeGetExpType(2) },
      set(newVal:Expense[]){ this._computeSetExpType(newVal,2); }
    },
    deleteExpenseList: {
      get():Expense[]{ return [] },
      set(newVal:Expense[]){ 
        Vue.set( this.product, 'expenses', this.product.expenses.filter((exp:Expense)=>exp.uuid != newVal[0].uuid) ); 
      }
    },
    formatSetExpenseType():boolean{
      return this.inputDump.formatSetExpenseTypeStatus == 1;
    },
    cursorStyle():string{
      const base64 = ()=>{
        switch(this.inputDump.setExpenseType){
          case 0: return 'data:image/png;base64,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';
          case 1: return 'data:image/png;base64,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';
          case 2: return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAABA0lEQVQokWNgYOR7zsQqZs5AJGBkUXB5y8jK+ZBFxW4ui7bnVELamEAEh3+74Z87h5L/XN2eTZQGUjQxIXOI0cSELkBIE4YGQpqwasCnCacGXJrwasCmiYWQBpimHxsrk4myAd0mvDb82Fh5Hl0MQ8O3Vbk/hCIncfz4y8jAwMjwn1lKfx2rSUQrTB7FSSDFbNpeJe9Xl94HO8Ov3ejPozNgt2NogCkGpVhGVo6XMHEQ+/eZFdVwDaCkjawY7E4l6yXf1xU/Atvi22Lx59GZJLgfOPzbjTA8pu059c+9ozEMDAxyYFsYmf7g9DQMsJlE9X1fV9zDyMF/lUXLfQNYnIGBAQAlTIBYtvgPQQAAAABJRU5ErkJggg==';
          default: return '';
        }
      }
      return `url(${base64()}), auto`;
    },
    retention:{
      get():number{ return this.product.retention; },
      cache: false
    },
    useStructure():boolean{return this.product.useStructure || false;},
    useCost():boolean{return this.product.useCost || false;},
    useUnit():boolean{return this.product.useUnit || false;},
    expenseTypeToClassMap():{t:number,c:string}[]{
      if(!this.product.useStructure) return [{t:-1,c:''},{t:0,c:''},{t:1,c:''},{t:2,c:''}];
      return [{t:-1,c:''},{t:0,c:'var'},{t:1,c:'const'},{t:2,c:'init'}];
    },
    productJson():any{
      return JSON.stringify(this.product, jsonCycler(),2);
    },
    ...mapGetters(['referencer','channels','product','projectData','isLoadingProject','isTesting'])
  },
  //https://stackoverflow.com/a/48377844
  filters: {
    pretty: function(value:any) {
      return JSON.stringify(JSON.parse(value), null, 2);
    },
    smartToFixed,
    numberWithSpaces
  }
})
